<template>
  <button
    class="relative block h-10.5 w-10.5 rounded-full focus:outline-none bg-grey overflow-hidden"
    @mouseover="$emit('change-colour', colour)"
  >
    <span
      :class="{
        'border-black': selectedColour && colour.id === selectedColour.id,
      }"
      class="absolute inset-0 z-20 border border-transparent transition duration-300 rounded-full"
      aria-hidden="true"
    />
    <img
      class="relative w-full h-full object-cover z-10"
      :src="colour.thumbnail.url"
      :alt="colour.title"
    />
  </button>
</template>

<script>
export default {
  name: "ColourSelectorCoatingButton",
  props: {
    colour: {
      type: [Object, Boolean],
      required: true,
    },
    selectedColour: {
      type: [Object, Boolean],
      required: true,
    },
  },
};
</script>
